export async function apiSendHeart(broadcastUID: string): Promise<Response> {
  const results = await fetch(
    `${import.meta.env.VITE_API_ENDPOINT}/broadcasts/${broadcastUID}/hearts`,
    {
      method: 'POST',
      credentials: 'include'
    }
  );

  if (results.ok) {
    return results;
  } else {
    throw results;
  }
}
